<template>
  <div class="page-wrapper">
    <!-- Background decoration -->
    <div class="bg-orb bg-orb-1"></div>
    <div class="bg-orb bg-orb-2"></div>
    <div class="bg-cross"></div>

    <div class="card-container">
      <div class="card">

        <!-- Logo -->
        <router-link to="/" class="logo-link">
          <img
            class="logo"
            src="https://res.cloudinary.com/dldd8ucby/image/upload/v1587167979/RA/WhatsApp_Image_2020-04-16_at_10.51.15_AM.jpg"
            alt="Logo"
          />
        </router-link>

        <!-- Header -->
        <div class="header">
          <h1 class="title">Welcome</h1>
          <p class="subtitle">Please fill in your details to begin the exam</p>
        </div>

        <!-- Form -->
        <form @submit.prevent="submit" class="form">

          <!-- First Name -->
          <div class="field">
            <label for="first_name">First Name</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </span>
              <input
                id="first_name"
                type="text"
                placeholder="e.g. Benjamin"
                v-model.trim="data.first_name"
              />
            </div>
          </div>

          <!-- Last Name -->
          <div class="field">
            <label for="last_name">Last Name</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </span>
              <input
                id="last_name"
                type="text"
                placeholder="e.g. Alamu"
                v-model.trim="data.last_name"
              />
            </div>
          </div>

          <!-- Church Select -->
          <div class="field">
            <label for="church">Church</label>
            <div class="input-wrapper select-wrapper">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              </span>
              <select id="church" v-model="data.church">
                <option disabled value="undefined">Select your church</option>
                <option
                  v-for="(church, index) in churches"
                  :key="index"
                  :value="church.name"
                >{{ church.name }}</option>
              </select>
              <span class="select-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </span>
            </div>
            <p v-if="errors.church" class="error-msg">Please select your church.</p>
          </div>

          <!-- Rank Select -->
          <div class="field">
            <label for="rank">Rank</label>
            <div class="input-wrapper select-wrapper">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              </span>
              <select id="rank" v-model="data.rank">
                <option disabled value="undefined">Select your rank</option>
                <option
                  v-for="(rank, index) in ranks"
                  :key="index"
                  :value="rank.name"
                >{{ rank.name }}</option>
              </select>
              <span class="select-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </span>
            </div>
            <p v-if="errors.rank" class="error-msg">Please select your rank.</p>
          </div>

          <!-- Loading overlay -->
          <vue-element-loading v-if="loading" :active="loading" :is-full-screen="true" />

          <!-- Submit Button -->
          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="!loading">
              Begin Exam
            </span>
            <span v-else class="loading-text">
              <svg class="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
              Loading...
            </span>
          </button>

        </form>

        <p class="footer-text">&copy; G1BRA</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ranks, churches } from "@/utils/data.js";

export default {
  data() {
    return {
      data: {
        church: "New Light Baptist Church, Magodo",
      },
      loading: false,
      errors: {},
      ranks,
      churches,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("ra-user"));
    if (this.user) {
      this.$router.push("/exam/take");
    }
  },
  methods: {
    ...mapActions(["login"]),
    async submit() {
      if (!this.data.first_name) {
        this.$toasted.error("Please enter your first name.").goAway(2500);
        return;
      }
      if (!this.data.last_name) {
        this.$toasted.error("Please enter your last name.").goAway(2500);
        return;
      }
      if (!this.data.rank) {
        this.$toasted.error("Please select your rank.").goAway(2500);
        return;
      }
      if (!this.data.church) {
        this.$toasted.error("Please select your church.").goAway(2500);
        return;
      }
      this.loading = true;
      try {
        let res = await this.login(this.data);
        if (res === true) {
          this.loading = false;
          this.$toasted.success("Login successful").goAway(2500);
          this.$router.push("/exam/take");
        } else {
          this.loading = false;
          this.$toasted.error(res.data.message).goAway(2500);
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=Jost:wght@300;400;500;600&display=swap');

/* ── Page Layout ── */
.page-wrapper {
  min-height: 100vh;
  background: #0f1923;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  font-family: 'Jost', sans-serif;
  position: relative;
  overflow: hidden;
}

/* ── Background Decorations ── */
.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  opacity: 0.18;
}
.bg-orb-1 {
  width: 500px; height: 500px;
  background: radial-gradient(circle, #c8a96e, transparent);
  top: -150px; right: -100px;
}
.bg-orb-2 {
  width: 400px; height: 400px;
  background: radial-gradient(circle, #3a5f8a, transparent);
  bottom: -100px; left: -80px;
}
.bg-cross {
  position: absolute;
  width: 180px; height: 180px;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.03;
  background:
    linear-gradient(#c8a96e 0 0) 50% 20%/20px 100%,
    linear-gradient(#c8a96e 0 0) 20% 35%/100% 20px;
  background-repeat: no-repeat;
}

/* ── Card ── */
.card-container {
  width: 100%;
  max-width: 460px;
  position: relative;
  z-index: 1;
}
.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 2.5rem 2.5rem 2rem;
  box-shadow:
    0 0 0 1px rgba(200, 169, 110, 0.15),
    0 24px 60px rgba(0,0,0,0.45),
    0 4px 16px rgba(0,0,0,0.3);
  animation: slideUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Logo ── */
.logo-link {
  display: block;
  text-decoration: none;
  margin-bottom: 1.5rem;
}
.logo {
  display: block;
  width: 72px;
  height: 72px;
  object-fit: contain;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(200, 169, 110, 0.25);
}

/* ── Header ── */
.header {
  text-align: center;
  margin-bottom: 1.75rem;
}
.title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 0.35rem;
  letter-spacing: 0.01em;
}
.subtitle {
  font-size: 0.85rem;
  color: #8a8fa8;
  font-weight: 300;
  letter-spacing: 0.02em;
  margin: 0;
}

/* ── Divider ── */
.header::after {
  content: '';
  display: block;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #c8a96e, #e8c98a);
  border-radius: 2px;
  margin: 0.85rem auto 0;
}

/* ── Form Fields ── */
.form { display: flex; flex-direction: column; gap: 1.1rem; }

.field { display: flex; flex-direction: column; gap: 0.4rem; }

label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4a4f6a;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 0.85rem;
  display: flex;
  align-items: center;
  color: #b0b5cc;
  pointer-events: none;
}
.input-icon svg { width: 15px; height: 15px; }

input,
select {
  width: 100%;
  padding: 0.65rem 0.9rem 0.65rem 2.5rem;
  font-family: 'Jost', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  color: #1a1a2e;
  background: #f7f8fc;
  border: 1.5px solid #e2e5f0;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  appearance: none;
  -webkit-appearance: none;
}
input::placeholder { color: #b8bdce; }
input:focus,
select:focus {
  border-color: #c8a96e;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(200, 169, 110, 0.12);
}

/* Select arrow */
.select-wrapper { position: relative; }
.select-arrow {
  position: absolute;
  right: 0.9rem;
  display: flex;
  align-items: center;
  color: #b0b5cc;
  pointer-events: none;
}
.select-arrow svg { width: 14px; height: 14px; }

/* Error */
.error-msg {
  font-size: 0.75rem;
  color: #e05252;
  margin: 0;
}

/* ── Submit Button ── */
.submit-btn {
  margin-top: 0.6rem;
  width: 100%;
  padding: 0.8rem 1.5rem;
  background: linear-gradient(135deg, #1a2a3e 0%, #243650 100%);
  color: #fff;
  font-family: 'Jost', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;
  box-shadow: 0 4px 16px rgba(26, 42, 62, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.submit-btn svg { width: 16px; height: 16px; transition: transform 0.2s; }
.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #c8a96e 0%, #e8c98a 100%);
  box-shadow: 0 6px 24px rgba(200, 169, 110, 0.4);
  transform: translateY(-1px);
}
.submit-btn:hover:not(:disabled) svg { transform: translateX(3px); }
.submit-btn:active:not(:disabled) { transform: translateY(0); }
.submit-btn:disabled { opacity: 0.65; cursor: not-allowed; }

/* Loading spinner */
.loading-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.spinner {
  width: 18px; height: 18px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── Footer ── */
.footer-text {
  text-align: center;
  font-size: 0.72rem;
  color: #c0c5d8;
  margin: 1.5rem 0 0;
  letter-spacing: 0.05em;
}

/* ── Responsive ── */
@media (max-width: 500px) {
  .card { padding: 2rem 1.5rem 1.75rem; }
  .title { font-size: 1.75rem; }
}
</style>